import { IsomorphicLogger, LogLevel, LogEntry } from './types'
import { createAppender } from './appenders'
import { SupabaseClient } from '@supabase/supabase-js'
import { getAuthUser } from '@/db/auth/users'
import { shouldLog } from './loggerConfig'

let supabaseClient: SupabaseClient | null = null

export function createClientLogger(namespace: string, client: SupabaseClient | null = null): IsomorphicLogger {
  supabaseClient = client
  const appender = createAppender()

  const logger: IsomorphicLogger = {
    async log(level: LogLevel, message: string, context?: Record<string, any>): Promise<void> {
			if (shouldLog(namespace, level)) {
				let user
	      if (supabaseClient) {
					user = await getAuthUser(supabaseClient, true)  //run with silent
	      }

				const userId = user?.email ?? 'server/unknown'

				const entry: LogEntry = {
					...context,
					timestamp: new Date().toISOString(),
					level,
					namespace,
					message,
					userId: userId,
				}
				// console.log('client logger', printObject(entry))
				await appender.append(entry)
			}
    },

    async trace(message: string, context?: Record<string, any>) {
      await this.log('trace', message, context)
    },

    async debug(message: string, context?: Record<string, any>) {
      await this.log('debug', message, context)
    },

    async info(message: string, context?: Record<string, any>) {
      await this.log('info', message, context)
    },

    async warn(message: string, context?: Record<string, any>) {
      await this.log('warn', message, context)
    },

    async error(message: string, context?: Record<string, any>) {
      await this.log('error', message, context)
    },

		isLoggingEnabled(level: LogLevel): boolean {
			return shouldLog(namespace, level)
		},

		isTraceEnabled(): boolean {
			return this.isLoggingEnabled('trace')
		},

		isDebugEnabled(): boolean {
			return this.isLoggingEnabled('debug')
		},

		isInfoEnabled(): boolean {
			return this.isLoggingEnabled('info')
		},

		isWarnEnabled(): boolean {
			return this.isLoggingEnabled('warn')
		},

		isErrorEnabled(): boolean {
			return this.isLoggingEnabled('error')
		}
  }

  return logger
}